import React from 'react';
import { MessageCircle, Mail } from 'lucide-react';
import Button from '../ui/Button';
import { BUSINESS_INFO } from '../../utils/constants';


const Hero = () => {
  return (
    
    <section className="hero">
    <div className="container">
        <div className="hero-content">
          <div className="badge animate-fade-in">
            <span className="animate-pulse" style={{width: '8px', height: '8px', backgroundColor: '#10b981', borderRadius: '50%', display: 'inline-block'}}></span>
            Professional Mobile Valeting Service
          </div>

          <h1>
            Luxury Shine, Delivered to Your
            <span className="hero-gradient-text">
              Doorstep & Workplace
            </span>
          </h1>

          <p>
            Mobile professional car valeting with flexible booking, premium products, 
            and trained technicians. We bring the showroom shine to you.
          </p>

          <div className="hero-buttons">
            <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button variant="whatsapp" size="lg" icon={MessageCircle}>
                Book Now on WhatsApp
              </Button>
            </a>
            <a href={`mailto:${BUSINESS_INFO.email}`}>
              <Button variant="secondary" size="lg" icon={Mail}>
                Email Us
              </Button>
            </a>
          </div>

          <div className="hero-stats">
            <div className="hero-stat">
              <div className="hero-stat-number">1+</div>
              <div className="hero-stat-label">Years Experience</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-number">100+</div>
              <div className="hero-stat-label">Happy Clients</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-number">100%</div>
              <div className="hero-stat-label">Mobile Service</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-number">4.9★</div>
              <div className="hero-stat-label">Average Rating</div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-wave">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;